<template>
  <div id="data-list-list-view" class="data-list-container">

    <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" search :data="forms">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-5 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item @click.stop="clickDel">
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>

          <!-- ADD NEW -->
          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ forms.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : forms.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="category">Custom Link</vs-th>
        <vs-th sort-key="popularity">Layout</vs-th>
        <vs-th sort-key="order_status">Start</vs-th>
        <vs-th sort-key="price">End</vs-th>
        <vs-th sort-key="price">Count Down Start</vs-th>
        <vs-th sort-key="price">Status</vs-th>
        <vs-th>Action</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody id="form-step-1">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.name }}</p>
              </vs-td>

              <vs-td>
                <p class="product-category">{{ tr.custom_link }}</p>
              </vs-td>

              <vs-td>
                <p class="product-category">{{ getLayoutName(tr.layout) }}</p>
              </vs-td>

              <vs-td>
                <p class="product-category">{{ formatDate(tr.start_at) }}</p>
              </vs-td>

              <vs-td>
                <p class="product-category">{{ formatDate(tr.end_at) }}</p>
              </vs-td>

              <vs-td>
                <p class="product-category">{{ formatDate(tr.countdown_start_at) }}</p>
              </vs-td>

              <vs-td>
                <vs-switch v-model="tr.status" @change="toggleFormStatus(tr.id, tr.status)"/>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <feather-icon icon="Share2Icon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-3" @click.stop="share(tr)" />
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-3" @click.stop="editData(tr)" />
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-3" @click.stop="deleteData(tr.id)" />
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>

    <template>
      <vs-popup classContent="popup-example" title="Share Form" :active.sync="popupSharer">
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button :href="fbsharedUrl" target="true" @click="closeSharer" color="primary" type="filled" class="w-full">
              <FbLogo class="logo" />
              Share with Facebook
            </vs-button>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button :href="washaredUrl" target="true" @click="closeSharer" color="primary" type="filled" class="w-full">
              <WaLogo class="logo" />
              Share with Whatsapp 
            </vs-button>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button :href="telegramsharedUrl" target="true" @click="closeSharer" color="primary" type="filled" class="w-full">
              <TelegramLogo class="logo" />
              Share with Telegram 
            </vs-button>
          </div>
        </div>
        <!--<div class="vx-row">-->
          <!--<div class="vx-col w-full">-->
            <!--<vs-button href="https://google.com" target="true" color="primary" type="border" class="w-full">-->
              <!--<WechatLogo class="logo" />-->
              <!--Share with We Chat -->
            <!--</vs-button>-->
          <!--</div>-->
        <!--</div>-->
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button @click="copyBrandedLink" color="primary" type="filled" class="w-full">
              <CopyLogo class="logo" />
              Copy Branded Link
            </vs-button>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button @click="copyLink" color="primary" type="filled" class="w-full">
              <CopyLogo class="logo" />
              Copy Link
            </vs-button>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button @click="copyQR" color="primary" type="filled" class="w-full">
              <QrLogo class="logo" />
              Share with QR Code
            </vs-button>
          </div>
        </div>
      </vs-popup>
    </template>

    <template>
      <vs-popup classContent="popup-example" title="QR Code" :active.sync="qrcodeSharer">
        <vue-qrcode :value="sharedUrl" :width="400" />
      </vs-popup>
    </template>
     <v-tour name="formTour" :steps="steps"></v-tour>
  </div>
</template>

<script>
import router from '@/router';
import FbLogo from './logo/facebook.vue';
import WaLogo from './logo/whatsapp.vue';
import TelegramLogo from './logo/telegram.vue';
import WechatLogo from './logo/wechat.vue';
import CopyLogo from './logo/copy.vue';
import QrLogo from './logo/qr.vue';
import VueQrcode from 'vue-qrcode';

const rootDomain = process.env.VUE_APP_ROOT_DOMAIN || "https://quicksend.asia/";

const getSubdomainUrl = (subdomain) => {
  let url = new URL(process.env.VUE_APP_ROOT_DOMAIN);
  let new_url = `${url.protocol}//${subdomain}.${url.hostname}`;

  if (typeof subdomain === "undefined" || subdomain === "") {
    new_url = `${url.protocol}//${url.hostname}`; // on some situation subdomain can be empty
  }

  return new_url;
}

const notifs = {
  error: (msg) => {
    return {
      title: 'Error',
      text: msg,
      iconPack: 'feather',
      icon: 'icon-alert-circle',
      color: 'danger'
    }
  },

  success: (msg) => {
    return {
      title: 'Success',
      text: msg,
      iconPack: 'feather',
      icon: 'icon-check-circle',
      color: 'success'
    }
  }
}

const layoutNames = [ 'Dropdown', 'Grid', 'Card' ];
const dialogs = {
  confirmDelete: (ids, callback) => {
    let text, title;

    if (ids.length > 1) {
      title = `Confirm Deletion of ${ids.length} forms`
      text = `Are you sure you want to delete these ${ids.length} forms?`
    } else {
      title = `Confirm Deletion`
      text = `Are you sure you want to delete this form?`
    }

    return {
      type: 'confirm',
      color: 'danger',
      title: title,
      text: text,
      accept: callback
    }
  }
}

export default {
  data () {
    return {
      selected: [],
      itemsPerPage: 5,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      popupSharer: false,
      formToShare: {},
      qrcodeSharer: false,

      // shared link
      sharedText: 'Order here',
      sharedUrl: '',
      steps: [
        {
          target: '#form-step-1', 
          header: {
            title: 'Order Forms Page',
          },
          content: `You’ll be able to manage your order forms at this page.`,
          params:{
              placement: 'top'
          }
        },
        {
          target: '#form-step-2', 
          header: {
            title: 'Share Your Order Form',
          },
          content: `Click on this button to share your order form to your customers and they’ll be able to purchase your products!`,
          params:{
              placement: 'top'
          }
        },
      ]
    }
  },

  mounted(){
    this.$tours['formTour'].start()
  },

  components: {
    FbLogo,
    WaLogo,
    TelegramLogo,
    WechatLogo,
    CopyLogo,
    QrLogo,
    VueQrcode,
  },

  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },

    forms () {
      return this.$store.state.form.forms;
    },

    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.forms.length
    },

    fbsharedUrl () {
      return `https://www.facebook.com/sharer.php?u=${encodeURIComponent(this.sharedUrl)}`;
    },

    washaredUrl () {
      return `https://api.whatsapp.com/send?text=${this.sharedText} ${encodeURIComponent(this.sharedUrl)}`;
    },

    telegramsharedUrl () {
      return `https://t.me/share/url?url=${encodeURIComponent(this.sharedUrl)}&text=${this.sharedText}`;
    },
  },
  methods: {
    addNewData () {
      router.push('/forms/new');
    },

    deleteData (id) {
      this.$vs.dialog(dialogs.confirmDelete(id, () => {
        this.$store.dispatch('form/removeForm', id).catch(err => { console.error(err) })
      }));
    },

    editData (data) {
      router.push(`/forms/${data.id}`);
    },

    formatDate (data) {
      let theDate = new Date(data);
      if (theDate.toString() !== 'Invalid Date' && !_.isEmpty(data)) {
        return theDate.toISOString().slice(0, 19).replace('T', ' ');
      }

      return 'not specified';
    },

    getLayoutName (idxLayout) {
      if (idxLayout < 0 || idxLayout > layoutNames.length + 1) {
        return `invalid layout ${idxLayout}`;
      }
      return layoutNames[idxLayout];
    },

    clickDel() {
      let ids = this.selected.map(x => x.id);
      this.$vs.dialog(dialogs.confirmDelete(ids, () => {
        this.$store.dispatch('form/removeForms', ids).catch(err => { console.error(err) })
      }));
    },

    toggleFormStatus(form_id, status) {
      let form = {
        id: form_id,
        status: status ? 1:0
      }

      this.$store.dispatch('form/updateForm', form);
    },

    share(form) {
      const domainUrl = getSubdomainUrl(this.$store.state.organization.current_organization[0].subdomain);
      const link = `${domainUrl}/#/buy/${this.formToShare.id}`;
      this.sharedUrl = `${domainUrl}/#/buy/${form.id}`
      this.formToShare = form;
      this.popupSharer = true;
    },

    copyBrandedLink() {
      const domainUrl = getSubdomainUrl(this.$store.state.organization.current_organization[0].subdomain);
      const customLink = this.formToShare.custom_link || this.formToShare.id;
      const brandedLink = `${domainUrl}/#/buy/${customLink}`;
      this.$copyText(brandedLink).then((x) => {
        this.$vs.notify(notifs.success("Branded Link copied."))
      }, (x) => {
        this.$vs.notify(notifs.error("Sorry, canot copy branded link."))
      })
      this.popupSharer = false;
    },

    copyLink() {
      const domainUrl = getSubdomainUrl(this.$store.state.organization.current_organization[0].subdomain);
      const link = `${domainUrl}/#/buy/${this.formToShare.id}`;
      this.$copyText(link).then((x) => {
        this.$vs.notify(notifs.success("Link copied."))
      }, (x) => {
        this.$vs.notify(notifs.error("Sorry, canot copy link."))
      })
      this.popupSharer = false;
    },

    copyQR() {
      this.qrcodeSharer = true;
      this.popupSharer = false;
    },

    closeSharer() {
      this.popupSharer = false;
    }
  },
  created () {
    this.$store.dispatch('form/refreshList');
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.btn {
  align: auto;
  display: inline-flex;
  align-items: center;
  margin-right: 10px;
  padding: 6px 10px;
  border-radius: 6px;
  width: 98%;
}

.btn-webpack { color: #1d78c1; }
.bnt-facebook { color: #5a7cc3; }

.logo {
  width: 28px;
  height: 28px;
  margin-right: 10px;
  vertical-align: middle;
}
.con-vs-popup .vs-popup {
  width: auto !important;
}

.vx-row {
  margin-bottom: 10px;
}
</style>
